import { z } from 'zod';

export enum EquipmentTypes {
    Van = 'VAN',
    Flatbed = 'FLATBED',
    Reefer = 'REEFER',
}

export enum GeoTypes {
    State = 'STATE',
    Region = 'REGION',
}

export enum RateTypes {
    Spot = 'BROKER_TO_CARRIER_SPOT',
    Contract = 'SHIPPER_TO_CARRIER_CONTRACT',
}

export const EquipmentTypeSchema = z.nativeEnum(EquipmentTypes);
export const GeoTypeSchema = z.nativeEnum(GeoTypes);
export const RateTypeSchema = z.nativeEnum(RateTypes);

export const EquipmentTypePayloadSchema = z.object({
    equipmentType: EquipmentTypeSchema,
});

export const MatrixRequestSchema = z.object({
    equipmentType: z.string(EquipmentTypeSchema),
    geoType: z.string(GeoTypeSchema),
    rateType: z.string(RateTypeSchema),
});

export type MatrixRequest = z.infer<typeof MatrixRequestSchema>;

export type CachedRequest = {
    request: MatrixRequest;
    link: string;
}

//export type EquipmentTypePayload = typeof EquipmentTypePayloadSchema;
